import styled, { css } from 'styled-components'

export const WrapperCheckbox = styled.label<{ className: string }>`
	position: relative;
	font-size: 16px;
	font-weight: normal;
	line-height: 24px;
	user-select: none;
	margin-bottom: 0;
	overflow: hidden;
	display: flex;
	align-items: center;
`

export const InputCheckbox = styled.input`
	position: absolute;
	z-index: -1;
	opacity: 0;
`
export const Checkbox = styled.span<{ checked: boolean }>`
	width: 16px;
	height: 16px;
	position: relative;
	top: 0;
	left: 0;
	display: block;
	background-color: #fff;
	border: 1px solid #d9d9d9;
	border-radius: 2px;
	&:after {
		${({ checked }) =>
			checked &&
			css`
				content: ' ';
				position: absolute;
				top: 44%;
				left: 20%;
				width: 5px;
				height: 9px;
				border: 2px solid #21ba72;
				border-top: 0;
				border-left: 0;
				opacity: 1;
				transform: rotate(45deg) scale(1) translate(-50%, -50%);
			`}
	}
`
